import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, InputBase, InputAdornment, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import SettingsHeader from './SettingsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined, CheckOutlined, ClearOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];   
    };
}

export interface IState {
    editAppVersion: boolean;
    appVersion: string;
    showLoader: boolean;
    imageSorted: string;
    familiesImpacted: string;
    productTypesMapped: string;
}

class Agents extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            editAppVersion: false,
            appVersion: '',
            showLoader: false,
            imageSorted: '',
            familiesImpacted: '',
            productTypesMapped: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.appVersion();
        this.appSettings();
        this.setState({

        })
    }

    public appVersion() {
        this.setState({ showLoader: true });
        let option = {
            'hierarchies': this.props.user.selectedHierarchyIds
        }
        axios.get(`appVersion`, {params: option}).then(response => {
          if (response.data.success) {
            this.setState({ showLoader: false });
            response.data.data.map((el: any) => {
                this.setState({appVersion: el.value})
            });
          }
        })
    }

    public appSettings(){
        this.setState({ showLoader: true });
        let option = {
            'hierarchies': this.props.user.selectedHierarchyIds
        }
        axios.get('appSettings', {params: option}).then(response => {
            if(response.data.success){
                this.setState({ showLoader: false });
                let temp = response.data.data;
                this.setState({
                    imageSorted: temp[2].value,
                    productTypesMapped: temp[3].value,
                    familiesImpacted: temp[4].value,
                })
                console.log(response.data.data);
            }
        })
    }

    public editAppversion(e: any){
        this.setState({ showLoader: true });
        let data = {
            'hierarchies': this.props.user.selectedHierarchyIds,
            'app_version': this.state.appVersion
        }
        axios.post('updateappVersion', data, { headers: { 'Content-Type': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                this.setState({showLoader: false});
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                })
                this.appVersion();
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
        this.setState({editAppVersion: false});
    }

    public updateAppSettings() {
        this.setState({ showLoader: true });
        let data = {
            'hierarchies': this.props.user.selectedHierarchyIds,
            'app_version': null,
            'families_impacted': this.state.familiesImpacted.toString(),
            'images_sorted_with_ai_ml_technologies': this.state.imageSorted,
            'product_types_waste_digitally_mapped': this.state.productTypesMapped.toString(), 
            'sms': 0
        }
        axios.post('updateappSettings', data, { headers: { 'Content-Type': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                this.setState({showLoader: false});
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                })
                this.appVersion();
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;


        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme:any) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <SettingsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            {/* <CardHeader
                                title="Settings"
                                className="text-left"
                                action={
                                    <CardActions>
                                    </CardActions>
                                }
                            /> */}
                            <CardContent className='text-left'>
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Typography>App Version</Typography>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        {/* <Typography>
                                            7.0.17 <Button size="medium" variant='contained'>Change</Button>
                                        </Typography> */}
                                        <FormControl variant="outlined">
                                            <InputLabel htmlFor="outlined-adornment-appversion">App Version *</InputLabel>
                                            <OutlinedInput
                                                id="outlined-adornment-appversion"
                                                disabled={!this.state.editAppVersion}
                                                value={this.state.appVersion}
                                                label="App Version"
                                                size='small'
                                                onChange={(e: any) => this.setState({appVersion: e.target.value})}
                                                required
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        {
                                                            !this.state.editAppVersion && <>
                                                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => this.setState({ editAppVersion: true })}>
                                                                    <EditOutlined />
                                                                </IconButton>
                                                            </>
                                                        }
                                                        {
                                                            this.state.editAppVersion && <>
                                                                <IconButton type="button" color="success" sx={{ p: '10px' }} aria-label="search" onClick={(e: any) => this.editAppversion(e)}>
                                                                    <CheckOutlined />
                                                                </IconButton>
                                                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                                                <IconButton type="button" color="error" sx={{ p: '10px' }} aria-label="directions" onClick={() => this.setState({ editAppVersion: false })}>
                                                                    <ClearOutlined />
                                                                </IconButton>
                                                            </>
                                                        }
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography>Image Sorted With AI/ML Technologies:</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="outlined-required"
                                            label="Images"
                                            defaultValue="10 Millions"
                                            value={this.state.imageSorted}
                                            onChange={(e: any) => {
                                                this.setState({imageSorted: e.target.value});
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography>Product Types Waste Digitally Mapped:</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="outlined-required"
                                            label="Product Types"
                                            defaultValue="1001"
                                            type="number"
                                            value={this.state.productTypesMapped}
                                            onChange={(e: any) => {
                                                this.setState({productTypesMapped: e.target.value});
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography>Families Impacted:</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="outlined-required"
                                            label="Families Impacted"
                                            defaultValue="116"
                                            type="number"
                                            value={this.state.familiesImpacted}
                                            onChange={(e: any) => {
                                                this.setState({familiesImpacted: e.target.value});
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} className='text-right'>
                                        <Button size="medium" variant='contained' onClick={() => this.updateAppSettings()}>Update Changes</Button>
                                    </Grid>
                                </Grid>
                                {/* <div>
                                    <div style={{'display': 'flex', 'justifyContent': 'space-between'}}>
                                        <Typography>App Version</Typography>
                                        <Typography>7.0.17 <Button size="medium" variant='contained'>Change</Button></Typography>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{'display': 'flex', 'justifyContent': 'space-between'}}>
                                        <Typography>Image Sorted With AI/ML Technologies:</Typography>
                                        <Typography><TextField
                                            required
                                            id="outlined-required"
                                            label="Images"
                                            defaultValue="10 Millions"
                                            />
                                        </Typography>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{'display': 'flex', 'justifyContent': 'space-between'}}>
                                        <Typography>Product Types Waste Digitally Mapped:</Typography>
                                        <Typography><TextField
                                            required
                                            id="outlined-required"
                                            label="Product Types"
                                            defaultValue="1001"
                                            type="number"
                                            />
                                        </Typography>    
                                    </div>
                                    <div>&nbsp;</div>
                                    <div style={{'display': 'flex', 'justifyContent': 'space-between'}}>
                                        <Typography>Families Impacted:</Typography>
                                        <Typography><TextField
                                            required
                                            id="outlined-required"
                                            label="Product Types"
                                            defaultValue="116"
                                            type="number"
                                            />
                                        </Typography>                                    
                                    </div>
                                    <Button size="medium" variant='contained'>Update Changes</Button>
                                </div> */}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

            </div>
        )
    }
}

export default withRouter(withTranslation()(Agents))